import { Button, TextInput, useNotify, required } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import Edit from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";

import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const EditPersonalDocumentsDataModal = ({ record, studentId, id, fetchData }) => {
  const notify = useNotify();
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
  const label = record
    ? "Редакция на данни за Документ за самоличност"
    : "Добавяне на данни за Документ за самоличност";

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      studentRequests.updateStudentPersonalDocuments({
        studentId: studentId,
        documentId: id,
      }),
      {
        number: data?.number,
        validUntil: data?.validUntil.split("T")[0],
      },
      "PUT",
      null,
    );

    fetchData();
    notify("Успешно променени данни", {
      type: "success",
    });
  };
  return (
    <FormModal
      titleContent={label}
      onConfirm={handleSubmit}
      confirmEnabled={isConfirmEnabled}
      defaultValues={record}
      triggerButton={
        <Button
          label={label}
          variant="contained"
          startIcon={record ? <Edit /> : <AddIcon />}
          sx={{ width: "max-content" }}
        />
      }
    >
      <FormContent setIsConfirmEnabled={setIsConfirmEnabled} />
    </FormModal>
  );
};
const FormContent = ({ setIsConfirmEnabled }) => {
  const {
    formState: { isDirty: formDirty },
  } = useFormContext();

  useEffect(() => {
    setIsConfirmEnabled(formDirty);
  }, [formDirty, setIsConfirmEnabled]);

  return (
    <Grid
      container
      spacing={2}
      gap={4}
      pt={4}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="validUntil"
            label="Валиден до"
            validate={[required("Задължително")]}
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="number"
            label="Номер на документ за самоличност"
            validate={required()}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
export default EditPersonalDocumentsDataModal;
